import { Injectable } from '@angular/core';
import type { Translation, TranslocoLoader } from '@jsverse/transloco';
import { of } from 'rxjs';

import de from '../assets/i18n/de.json';
import en from '../assets/i18n/en.json';
import it from '../assets/i18n/it.json';
import nl from '../assets/i18n/nl.json';

import {
  WORKFORCE_DEFAULT_LANG,
  WORKFORCE_LANGS,
  type WorkforceLang,
} from './i18n/workforce-langs';

const TRANSLATIONS: Record<WorkforceLang, Translation> = { en, de, it, nl };

function resolveTranslation(lang: string): Translation {
  if (WORKFORCE_LANGS.includes(lang as WorkforceLang)) {
    return TRANSLATIONS[lang as WorkforceLang];
  }
  return TRANSLATIONS[WORKFORCE_DEFAULT_LANG];
}

/**
 * Bundles locale JSON at build time so translations work in SSR and production
 * without relying on runtime HTTP fetches to `/assets/i18n/*.json`.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: string) {
    return of(resolveTranslation(lang));
  }
}
